import { PermissionType } from "@shared/api"
import { retryDynamicImport } from "@shared/lib"
import {
	declarationCreation,
	declarationDetailsForm,
	materialDetails,
	materials,
	selectionOfDeclarationTypeForm,
	selectionOfMaterialForm,
} from "@shared/routes"
import { RouteGuard } from "@shared/ui/route-guard"
import { Outlet, RouteObject } from "react-router-dom"

const lazyDeclarationCreation = () =>
	retryDynamicImport(() => import("../declaration-creation")).then(m => ({
		Component: m.DeclarationCreationPage,
	}))

export default [
	{
		path: materials,
		element: (
			<RouteGuard
				requiredPermissions={[
					PermissionType.Customer,
					PermissionType.SalesRepresentative,
				]}
			>
				<Outlet />
			</RouteGuard>
		),
		children: [
			{
				index: true,
				lazy: () =>
					retryDynamicImport(
						() => import("../manage-declarations"),
					).then(m => ({
						Component: m.ManageDeclarationsPage,
					})),
			},
			{
				path: materialDetails,
				children: [
					{
						index: true,
						lazy: () =>
							retryDynamicImport(
								() => import("../material-details"),
							).then(m => ({
								Component: m.MaterialDetailsPage,
							})),
					},
					{
						path: selectionOfDeclarationTypeForm,
						lazy: lazyDeclarationCreation,
					},
					{
						path: selectionOfMaterialForm,
						lazy: lazyDeclarationCreation,
					},
					{
						path: declarationDetailsForm,
						lazy: lazyDeclarationCreation,
					},
					{
						path: declarationCreation,
						children: [
							{
								path: selectionOfDeclarationTypeForm,
								lazy: lazyDeclarationCreation,
							},
							{
								path: selectionOfMaterialForm,
								lazy: lazyDeclarationCreation,
							},
							{
								path: declarationDetailsForm,
								lazy: lazyDeclarationCreation,
							},
						],
					},
				],
			},
		],
	},
] satisfies RouteObject[]
